export default {

    async reset({ commit }) {
        commit('reset')
    },

    async send({ state, dispatch, commit, rootState, getters, rootGetters }, payload) {
        let results = { ok: false }

        try {
            if (getters['ready']) {
                commit('set', { uploaded: true })
                let responses = await dispatch('v4/panel/responses', { version: 4 }, { root: true })
                let details = rootGetters['v4/session/details']('array')
                let assessment = rootGetters['v4/mrx/bundle'].filter(item => (item.type === 'assessment'))

                let body = [].concat(details, assessment, responses)

                const options = {
                    method: 'POST',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(body)
                }
                results = fetch('api/v3/stream', options)
            }
        }
        catch (e) {
            console.log(e)
        }
        return results
    }
}
